/**
 * @author vishwadeep.kapoor
 * @Date: 2018-08-28 19:30:32
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-04 20:30:01
 */

import React, { PureComponent, Fragment } from 'react';
import { string, bool, func, shape } from 'prop-types';
import { Flex, Box } from 'grid-styled';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from 'react-fontawesome';

import endPoints from '../../config/endPoints';
import Button from '../../components/Button';
// import SelectWrapper from '../../components/SelectWrapper';
import Input from '../../components/Input';
import { TopMenu, MainMenu, SeconderyMenu } from '../../components/MobileMenu';
import FooterPhoneImage from '../../assets/images/footerphoneimage.png';
import { MOBILE_MENU_CONFIG } from './constants';
import { constants, utils } from '../../devUtils';

import LogoutIcon from '../../assets/images/logout-icon.png';
import MyAccount from '../../assets/images/my-account.png';
import MenuIcon from '../../assets/images/menu.svg';
import SearchIcon from '../../assets/images/search-icon.svg';
import ShoppingIcon from '../../assets/images/shopping-cart.svg';
import ProfileIcon from '../../assets/images/profile.svg';
import BackBtn from '../../assets/images/back-btn.svg';
import UserProfile from '../../assets/images/user-icon.png';
import NewsCarousel from '../../components/NewsCarousel';
import ManipalcignaHeader from './manipalcignaHeader';
import PropelCorporateGiftingHeader from './propelCorporateGiftingHeader';
import CorporateIcon from '../../assets/images/corporate_mobile_icon.png';

class MobileHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      /** @todo use isShowSearch in place of isEnableSearch */
      // isShowSearch: false,
    };
  }

  componentDidMount() {
    function myFunction() {
      document.getElementById('main-menu-checkbox').click();
    }
    const el = document.getElementById('closeMenu');
    if (el) {
      el.onclick = () => {
        myFunction();
      };
    }
  }

  renderManipalsignaHeader() {
    const {
      isOnlyMerchandise = false,
      cart,
      loggedIn,
      handleLogout,
      history,
      history: {
        location: {
          pathname,
        },
      },
      LoginClick,
    } = this.props;
    return (
      <ManipalcignaHeader
        isOnlyMerchandise={[constants.LINK_CLIENT_MANIPAL, constants.LINK_MANIPAL_ABOUTUS, constants.LINK_MANIPAL_REFUN_RETURN_POLICY].includes(pathname) || isOnlyMerchandise}
        loggedIn={loggedIn}
        cart={cart}
        handleLogout={handleLogout}
        handleShowLogin={LoginClick}
        history={history}
      />
    );
  }

  renderPropelCorporateGiftingHeader() {
    const {
      isOnlyMerchandise = false,
      cart,
      loggedIn,
      handleLogout,
      history,
      LoginClick,
    } = this.props;
    return (
      <PropelCorporateGiftingHeader
        isOnlyMerchandise={isOnlyMerchandise}
        loggedIn={loggedIn}
        cart={cart}
        handleLogout={handleLogout}
        handleShowLogin={LoginClick}
        history={history}
      />
    );
  }

  renderSearch() {
    const {
      isEnableSearch,
      TEXT_SEARCH_PLACEHOLDER,
      is_EnableSearch,
      handleSearch,
      handleSearchSubmit,
      stateLessKeys,
    } = this.props;
    if (is_EnableSearch) {
      return (
        <Box w={12 / 12} className="mobile-search">
          <span className="close" onClick={isEnableSearch} role="presentation">
            <FontAwesomeIcon name="close" />
          </span>
          <Input type="text" placeholder={TEXT_SEARCH_PLACEHOLDER} onChange={handleSearch} defaultValue={stateLessKeys.searchValue} />
          <Button type="primary" onClick={handleSearchSubmit}>
            <FontAwesomeIcon name="search" />
          </Button>
        </Box>
      );
    }
    return '';
  }

  renderMobileSideMenu() {
    const {
      isOnlyMerchandise,
      loggedIn,
    } = this.props;
    const RedirectInvestorRelationExternalLink = (link) => { window.location.href = link; };
    return (
      <Fragment>
        {MOBILE_MENU_CONFIG.filter((item) => isOnlyMerchandise ? item.link === constants.LINK_MY_PROFILE : true).map((item) => (
          (item.isAuthRequire) ?
            (
              loggedIn && (
                <li key={item.name}>
                  <Link to={item.link} className={item.linkClass}>
                    <img src={item.image} alt={item.name} />{item.name}
                  </Link>
                  {item.submenu && (
                    <ul>
                      {item.submenu_list.filter((itemSub) => isOnlyMerchandise ? itemSub.link !== constants.LINK_MY_BOOKINGS : true).map((menu) => (
                        <li key={menu.name}>
                          <Link to={menu.link}>{menu.name}</Link>
                        </li>
                      ))}
                    </ul>
                  )
                  }
                </li>
              )
            ) :
            (
              <li key={item.name} className="dropdown">
                <Link to={item.link}>
                  <img src={item.image} alt={item.name} />{item.name}
                </Link>
                { item.submenu && (
                  <ul>
                    {item.name === 'Save' ? item.submenu_list.map((menu) => (
                      <li key={menu.name}>
                        <Link to={menu.link}>{menu.name}</Link>
                      </li>
                    )) : item.submenu_list.map((menu) => (
                      <li key={menu.name}>
                        <Link to={menu.link} target={menu.target}>
                          {menu.link === '#/' ? <strong>{menu.name}</strong> : menu.name}
                        </Link>
                      </li>
                    )) }
                  </ul>
                )}
              </li>
            )
        ))}
        <li>
          <div
            className="cursor clr-black"
            role="presentation"
            onClick={() => RedirectInvestorRelationExternalLink(constants.LINK_INVESTOR_RELATIONS)}
          >
            <img
              src={CorporateIcon}
              alt="corporate-icon"
              className="corp-icon"
            /> Investor Relations
          </div>
        </li>
        <li>
          <div
            className="cursor clr-black"
            role="presentation"
            onClick={() => RedirectInvestorRelationExternalLink(constants.LINK_TRUST_CENTER)}
          >
            <img
              src={CorporateIcon}
              alt="corporate-icon"
              className="corp-icon"
            /> Trust Center
          </div>
        </li>
      </Fragment>
    );
  }

  renderMainMenu() {
    const {
      isEnableSearch,
      isOnlyMerchandise,
      handleLogout,
      handleBackButton,
      cart,
      name,
      LINK_ANDROID_APP,
      getHeaderConfigUi: {
        isMenuIconShow,
        showSearch,
        isCartShow,
      },
      loggedIn,
      LoginClick,
      gotoProfile,
      isLoginSuccess,
      history: {
        location: {
          pathname,
        },
      },
    } = this.props;
    return (
      <MainMenu className={[constants.LINK_CLIENT_MANIPAL, constants.LINK_MANIPAL_ABOUTUS, constants.LINK_MANIPAL_REFUN_RETURN_POLICY].includes(pathname) ? 'mb-none-1' : ''}>
        <Flex flexWrap="wrap">
          <Box w={4 / 12} className="left">
            <input id="main-menu-checkbox" type="checkbox" />
            {!isMenuIconShow && <img src={BackBtn} alt="logo" onClick={handleBackButton} className="backBtn" role="presentation" />}
            <header>
              {isMenuIconShow &&
              <label htmlFor="main-menu-checkbox" className="menu-toggle">
                <span className="sr-only">Open main menu</span>
                <img src={MenuIcon} alt="" height={22} width={22} className="height-auto" />
              </label>}
              <nav id="main-menu" className="main-menu" aria-expanded="false" aria-label="Main menu">
                <label htmlFor="main-menu-checkbox" className="menu-close">
                  <span className="sr-only">Close main menu</span>
                  <span className="fa fa-close" aria-hidden="true"></span>
                </label>
                <ul id="closeMenu">
                  <li className="location">
                  </li>
                  {
                    loggedIn ? (
                      <span>
                        <li className="profile">
                          <Link to={isOnlyMerchandise ? constants.LINK_CLIENT_MANIPAL : constants.LINK_HOME} className="border">
                            <img src={UserProfile} alt="" />
                            <span>
                              {name}
                            </span>
                          </Link>
                        </li>
                        <br clear="all" />
                      </span>
                    ) : (
                      <li onClick={LoginClick} role="presentation">
                        <Link to={constants.LINK_HOME}>
                          <img src={MyAccount} alt="no_image" />Login/Sign Up
                        </Link>
                      </li>
                    )
                  }
                  {this.renderMobileSideMenu()}
                  {
                    (loggedIn || isLoginSuccess) ? (
                      <li onClick={handleLogout} role="presentation">
                        {isOnlyMerchandise ? (
                          <div className="a">
                            <img src={LogoutIcon} alt="" />Log out
                          </div>
                        ) :
                          (
                            <Link to={constants.LINK_HOME}>
                              <img src={LogoutIcon} alt="" />Log out
                            </Link>
                          )
                        }
                      </li>
                    ) : ''
                  }
                  <li className="download">
                    <a href={LINK_ANDROID_APP} target="_blank">
                      <span><img src={FooterPhoneImage} alt="" />Download Zaggle App</span>
                    </a>
                  </li>
                </ul>
              </nav>
              <label
                htmlFor="main-menu-checkbox"
                className="backdrop"
                tabIndex="-1"
                aria-hidden="true"
                hidden
              >
              </label>
            </header>
          </Box>
          <Box w={4 / 12} className="logo">
            <Link to={isOnlyMerchandise ? constants.LINK_CLIENT_MANIPAL : constants.LINK_HOME}>
              <img src={isOnlyMerchandise ? endPoints.MANIPAL_LOGO : endPoints.ZAGGLE_LOGO.URL} alt={endPoints.ZAGGLE_LOGO.ALT} className={isOnlyMerchandise ? 'manipal-logo' : 'zaggle-logo'} />
            </Link>
          </Box>
          {!utils.getWindowInstance().location.pathname.includes(constants.LINK_CONTACTUS) &&
          <Box w={4 / 12} className="right">
            {(showSearch && !isOnlyMerchandise) &&
            <span className="search" onClick={isEnableSearch} role="presentation">
              <img src={SearchIcon} alt="" className="height-auto" height={22} width={22} />
            </span>}
            {isCartShow &&
            <Link to={constants.GIFT_CARD_CART}>
              <span className="cart">
                {/* {cart && cart.items_count && <b>{cart.items_count}</b>} */}
                {
                  (cart && cart.items_count && cart.items_count !== 0) ?
                    <b>{cart.items_count}</b> :
                    null
                }
                <img src={ShoppingIcon} alt="" className="height-auto" height={22} width={22} />
              </span>
            </Link>}
            <span className="profile-img" onClick={loggedIn ? gotoProfile : LoginClick} role="presentation">
              <img src={ProfileIcon} alt="" className="height-auto" height={20} width={20} />
            </span>
          </Box>}
          {this.renderSearch()}
        </Flex>
      </MainMenu>
    );
  }

  renderMobileHeader() {
    const {
      isOnlyMerchandise,
      history: {
        location: {
          pathname,
        },
      },
      client_series,
    } = this.props;
    if ([constants.LINK_PROPEL_CORPORATE_GIFITING_HOME].includes(pathname) || (client_series === endPoints.PROPEL_CORPORATE_GIFTING)) {
      return this.renderPropelCorporateGiftingHeader();
    } else if (isOnlyMerchandise || [constants.LINK_CLIENT_MANIPAL, constants.LINK_MANIPAL_ABOUTUS, constants.LINK_MANIPAL_REFUN_RETURN_POLICY].includes(pathname)
    || (client_series === endPoints.PROPEL_CORPORATE_GIFTING)) {
      return this.renderManipalsignaHeader();
    } else if ([constants.LINK_PROPEL_CORPORATE_GIFITING].includes(pathname)) {
      return '';
    }
    return this.renderMainMenu();
  }

  /**
   * @todo: need to configure the state of this module in it only
   */
  render() {
    const {
      getHeaderConfigUi: {
        isMenuIconShow,
        showGiftCardLinks,
        isRedTapeShow,
      },
    } = this.props;
    return (
      <div className="lg-none" >
        <NewsCarousel />
        {!isMenuIconShow &&
          <TopMenu>
            <ul>
              <li className="location">
              </li>
            </ul>
          </TopMenu>}
        {this.renderMobileHeader()}
        {isRedTapeShow ?
          <SeconderyMenu>
            <ul>
              {/* {showRestroDealLinks && <li><Link to={constants.LINK_RESTAURANTS_DEALS}>Restaurant<br /> Deals</Link></li>} */}
              {showGiftCardLinks && <li><Link to={constants.LINK_GIFTCARD_LANDING}>Gift Card<br /> Deals</Link></li>}
              <li><Link to={constants.LINK_HOME}>Corporate<br /> Solutions</Link></li>
            </ul>
          </SeconderyMenu> : ''}
      </div>
    );
  }
}
MobileHeader.propTypes = {
  isOnlyMerchandise: bool,
  loggedIn: bool.isRequired,
  is_EnableSearch: bool.isRequired,
  isLoginSuccess: bool.isRequired,
  TEXT_SEARCH_PLACEHOLDER: string.isRequired,
  name: string,
  LINK_ANDROID_APP: string.isRequired,
  cart: shape({}),
  handleBackButton: func.isRequired,
  stateLessKeys: shape({}).isRequired,
  getHeaderConfigUi: shape({
    showSearch: bool.isRequired,
    showRestroDealLinks: bool.isRequired,
    showGiftCardLinks: bool.isRequired,
    primaryHeaderTitle: string.isRequired,
    topHeaderImage: string,
  }).isRequired,
  client_series: string.isRequired,
  handleSearch: func.isRequired,
  handleSearchSubmit: func.isRequired,
  isEnableSearch: func.isRequired,
  handleLogout: func.isRequired,
  LoginClick: func.isRequired,
  gotoProfile: func.isRequired,
  history: shape({}).isRequired,
};

MobileHeader.defaultProps = {
  name: '',
  cart: {},
  isOnlyMerchandise: false,
};
export default MobileHeader;



// WEBPACK FOOTER //
// client/containers/HeaderContainer/mobileHeader.js